// Nhãn hiển thị cho từng loại kết quả tìm kiếm.
// Tách riêng để không kéo toàn bộ dữ liệu tìm kiếm vào bundle chính.
export const getTypeLabel = (type) => {
  const labels = {
    'news': 'Tin tức',
    'party-politics': 'Công tác Đảng',
    'cooperation': 'Nghiên cứu - Hợp tác',
    'organization': 'Tổ chức',
    'departments': 'Phòng ban'
  }
  return labels[type] || 'Khác'
}
